import { Component, Input } from '@angular/core';
import { EventRegistration } from '../../../services';

@Component({
    selector: 'employers-attending-overview',
    templateUrl: './employers-attending-overview.component.html'
})
export class EmployersAttendingOverviewComponent {
    @Input()
    public eventId: string;

    @Input()
    public set employersAttending(employersAttending: EventRegistration[]) {
        employersAttending.find(employer => {
            if (this.employersWithLogo.length === 5) {
                return;
            } else if (employer.logo) {
                this.employersWithLogo.push(employer);
            }
        });

        this.employers = employersAttending.slice(0, 5);
    }

    public employers: EventRegistration[] = [];
    public employersWithLogo: EventRegistration[] = [];
}
